'use strict';

const template = `<pmt-elm
			module="LocationSelectorPort"
			args="$ctrl.args"
			subscriptions="$ctrl.subscriptions"
		></pmt-elm>`;

function Controller() {
	const $ctrl = this;

	$ctrl.args = {
		siteName: $ctrl.siteName,
		realm: $ctrl.realm,
		network: $ctrl.network || '',
		target: $ctrl.target || '',
		selected: $ctrl.selectedLocations || []
	};

	$ctrl.subscriptions = [
		{
			id: 'LocationsSelected',
			f: $ctrl.onSelected
		}
	];
}

Controller.$inject = [];

angular.module('PinMeTo.selectors').component('pmtLocationSelector', {
	template: template,
	controller: Controller,
	bindings: {
		siteName: '<',
		realm: '<',
		network: '<?',
		target: '<?',
		selectedLocations: '<',
		onSelected: '<'
	}
});
